function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function formattedTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString('fi-FI', { timeZone: 'Europe/Helsinki' });
}

function capitalize(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}

async function fetchData(topic, params) {
    const queryString = params && Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : '';
    const url = `${this.$url}/${topic}${queryString}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + getCookie('token'),
                ContentType: 'application/json'
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data for ' + topic + ':', error);
        return [];
    }
}

module.exports = {
    getCookie,
    formattedTime,
    capitalize,
    fetchData
};